import axios from "@utils/api/axiosInstance";
import { SMS_TEMPLATE } from "@utils/constants";
import { printInConsole } from "@utils/devtools/utils";

export async function getAllCommunityEvents({
  accessToken,
  page = 0,
  filter = "All",
}) {
  let link,
    data = null,
    err = null;

  if (page === 0) {
    link = "kriya/web";
  } else {
    link = `kriya/web?page=${page}&filter=${filter}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  // if (language) {
  //   reqOptions.headers = {
  //     ...reqOptions.headers,
  //     language: language,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });
  //console.log("All Events data  => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;
  //console.log("All Events data  => ", response);

  return { data, err };
}

export async function getSearchedCommunityEvent({ search, page = 0 }) {
  let link,
    data = null,
    err = null;
  if (page === 0) {
    link = `kriya/search?query=${search}&isPrasad=true`;
  } else {
    link = `kriya/search?page=${page}&query=${search}&isPrasad=true`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function getRazorpayPaymentOrderID({ amount, accessToken }) {
  /*
    Returns the razorpay order id
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`event/registration/order-id?amount=${amount * 100}`),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  // printInConsole("Order ID data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function createJuspaySession({
  uid,
  registrationID,
  eventUrlExtension,
  subEventUrlExtension,
  contact,
  firstName,
  lastName,
  amount,
  source,
  language,
  isDigital,
  return_url,
  accessToken,
}) {
  /*
    Returns the razorpay order id
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "POST",
    url: encodeURI(`event/registration/juspay/order-id`),
    data: {
      uid: uid,
      registrationID: registrationID,
      eventUrlExtension: eventUrlExtension,
      subEventUrlExtension: subEventUrlExtension,
      contact: contact,
      firstName: firstName,
      lastName: lastName,
      amount: amount,
      source: source,
      language: language,
      isDigital: isDigital,
      return_url: return_url,
    },
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  // printInConsole("Order ID data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function fetchJuspayOrderIdStatus({ order_id, accessToken }) {
  /*
    Returns the razorpay order id
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `event/registration/juspay/order-status?order_id=${order_id}`
    ),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  // console.log("Order ID data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}
/*
  Returns the event details
  accessToken --> required
*/
export async function getEventDetails({ urlExtension, accessToken }) {
  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`community/event/web?eventID=${urlExtension}`),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function getSubEventDetails({
  urlExtension,
  eventUrlExtension,
  accessToken,
}) {
  /*
    Returns the event details
    accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `community/event/sub?subEventID=${urlExtension}&eventID=${eventUrlExtension}`
    ),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function getEventRegistration({ registrationID, accessToken }) {
  /*
    Returns the event details
    accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`event/registration?registrationID=${registrationID}`),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //console.log("Event data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function getEventAllRegistrations({
  eventID,
  accessToken,
  cancelToken,
  ts,
}) {
  /*
    Returns the event details
  */
  let url;
  if (ts) {
    url = `event/registration/all?eventID=${eventID}&ts=${ts}`;
  } else {
    url = `event/registration/all?eventID=${eventID}`;
  }

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(url),
    // cancelToken: cancelToken
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //console.log("Event data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function getRecommendedEvent({
  urlExtension,
  accessToken,
  eventUrlExtension,
}) {
  let data = null;
  let err = null;
  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `event/registration/recommended?eventID=${eventUrlExtension}`
    ),
  };
  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }
  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });
  // console.log("Recommended  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function eventRegistration({
  eventID,
  name,
  email,
  contact,
  subEventID,
  referrerID,
  utm_medium,
  utm_source,
  utm_campaign,
  utm_content,
  source,
  eventStart,
  language,
}) {
  /*
    Returns the event details
  */
  let linkTrackingObj = null;
  if (
    utm_medium !== null ||
    utm_source !== null ||
    utm_campaign !== null ||
    utm_content !== null
  ) {
    linkTrackingObj = {
      campaignName: utm_campaign,
      campaignContent: utm_content,
      campaignMedium: utm_medium,
      campaignSource: utm_source,
    };
  }
  const reqOptions = {
    method: "POST",
    url: encodeURI("event/registration"),
    data: {
      eventID,
      name,
      email,
      contact,
      subEventID,
      referrerID,
      linkTracking: linkTrackingObj,
      source,
      eventStart,
      language,
    },
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    printInConsole(error);
  });

  // console.log("Event registration data  => ", response);

  // if (response?.data?.success) return response.data.response;

  // return null;
  return response?.data;
}

export async function postBhetDaan(body) {
  /*
    Returns the event details
  */

  const reqOptions = {
    method: "POST",
    url: encodeURI("event/registration/bhet-daan/v1"),
    data: body,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    printInConsole(error);
  });

  // console.log("Event registration data  => ", response);

  // if (response?.data?.success) return response.data.response;

  // return null;
  return response?.data;
}

export async function updateEventRegistration({ data, accessToken }) {
  const reqOptions = {
    method: "PUT",
    url: encodeURI("community/event/registration/update/v2"),
    data: data,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }
  //console.log("Update Event Registration data", data);

  const response = await axios(reqOptions).catch((error) => {
    printInConsole(error);
  });

  //console.log("Event registration data  => ", response);

  if (response?.data?.success) return response.data.success;

  return null;
}

export async function getAllEvents({
  communityID,
  ts = 0,
  accessToken,
  cancelToken,
}) {
  /*
    Returns the all event of a community
  */

  let data = null,
    err = null,
    query = null;

  query = `communityID=${communityID}`;
  if (ts) {
    query = `communityID=${communityID}&ts=${ts}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(`community/event/all?${query}`),
    //cancelToken: cancelToken,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    printInConsole(error);
  });

  //console.log("All Events data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return data;
}

export async function uploadEventAboutImage({ files, accessToken }) {
  /*
  Upload dp and cover of community
  */

  const formData = new FormData();
  files.forEach((item) => {
    formData.append("image", item);
  });

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/event/image"),
    data: formData,
  }).catch((err) => printInConsole(err));

  //console.log("uploadImage => ", response);

  // ! To be changed
  // if (response?.data?.success) return response.data.response;
  // return null;
  return response?.data;
}

export async function createEventAbout({ data, accessToken }) {
  //printInConsole("Create post data => ", data);

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("community/event/about"),
    data: data,
  }).catch((err) => {
    printInConsole(err);
  });

  //console.log("Create event response => ", response);

  // if (response?.data?.success) return response.data.response;

  // return null;
  return response?.data;
}

export async function getSingleEventAbout({
  eventID,
  accessToken,
  domainName,
}) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;
  let url;

  if (domainName) {
    url = encodeURI(
      `community/event/about?eventID=${eventID}&domainName=${domainName}`
    );
  } else {
    url = encodeURI(`community/event/about?eventID=${eventID}`);
  }

  //console.log("Event Id: ", eventID);
  const reqOptions = {
    method: "GET",
    url: url,
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Single Blog Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function updateEventAbout({ data, accessToken }) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "PUT",
    url: encodeURI("community/event/about"),
    data: data,
  }).catch((err) => {
    printInConsole(err);
  });

  // console.log("Update blog fun => ", data);

  //console.log("Update event about response => ", response);

  // if (response?.data) return response.data.response;

  // return null;
  return response?.data;
}

export async function updateEventRegistrationAddress({ data, accessToken }) {
  const reqOptions = {
    method: "POST",
    url: encodeURI("event/registration/address"),
    data: data,
  };
  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }
  const response = await axios(reqOptions).catch((err) => {
    printInConsole(err);
  });

  //console.log("Update event registration address fun => ", data);

  // console.log("Update event registration address response => ", response);

  // if (response?.data) return response.data.success;

  // return null;
  return response?.data;
}

export async function checkServiceability({
  destinationPincode,
  paymentMode,
  eventID,
  amount,
  destinationState,
  destinationCountry,
}) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(
      `community/event/registration/serviceability?destinationPincode=${destinationPincode}&paymentMode=${paymentMode}&eventID=${eventID}&amount=${amount}&destinationState=${destinationState}&destinationCountry=${destinationCountry}`
    ),
  }).catch((err) => {
    printInConsole(err);
  });

  //console.log("Update event registration address fun => ", data);

  //console.log("Update event registration address response => ", response);

  if (response?.data) return response.data;

  return null;
}

export const getEventData = async ({ eventID, deityTypeName }) => {
  /*
    Returns the event details
  */

  let data = null,
    err = null;

  let reqOptions;
  if (
    deityTypeName === undefined ||
    deityTypeName === null ||
    deityTypeName === ""
  ) {
    reqOptions = {
      method: "GET",
      url: encodeURI(`community/event/web?eventID=${eventID}`),
    };
  } else {
    reqOptions = {
      method: "GET",
      url: encodeURI(
        `community/event/web?eventID=${eventID}&deityTypeName=${deityTypeName}`
      ),
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //console.log("Event data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
};

export const getEventUserDetails = async ({
  eventID,
  eventTypeID,
  communityID,
  accessToken,
}) => {
  /*
    Returns the event related user details
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `community/event/user?eventID=${eventID}&eventTypeID=${eventTypeID}&communityID=${communityID}`
    ),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //console.log("Event data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
};

// for download receipt on /community/event/registration/downloadReceipt -
// Download Recipt (registrationID) - GET request, send a registrationID in query params

export const downloadReceipt = async ({ registrationID, accessToken }) => {
  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `event/registration/downloadReceipt?registrationID=${registrationID}`
    ),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  // console.log("Event data  => ", response.data);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
};

// to send invoice over email on /community/event/registration/sendInvoicesOverMail
// - Send Invoices Over Mail (registrationID, email) - POST request, send in body

export const sendInvoicesOverMail = async ({
  registrationID,
  email,
  accessToken,
}) => {
  let data = null,
    err = null;

  const reqOptions = {
    method: "POST",
    url: encodeURI(`event/registration/sendInvoicesOverMail`),
    data: {
      registrationID,
      email,
    },
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  // console.log("Event data  => ", response.data);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
};

export async function getTrackingStatusForUser({ trackingID }) {
  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `event/registration/status/user/v2?registrationID=${trackingID}&platform=${SMS_TEMPLATE.WEBSITE}`
    ),
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response?.data?.message;
  // console.log("statusApi: ", response.data);
  return { data, err };
}

export async function getAllPastBookings({ accessToken, ts }) {
  let data = null,
    err = null;

  const url = ts
    ? encodeURI(`kriya/allRegistrations?ts=${ts}`)
    : encodeURI(`kriya/allRegistrations`);

  const reqOptions = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response?.data?.message;

  return { data, err };
}

export async function getAllRevalidatedEvents() {
  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI("kriya/web/revalidateEvents"),
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  // console.log("Events====>",response)

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function getEventFromBenefitID({ benefitID, page = 0 }) {
  let data = null,
    err = null;

  let url = `kriya/web/benefit-pujas/v2?page=${page}&benefitID=${benefitID}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(url),
  }).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response?.data?.message;

  return { data, err };
}

export async function getSearchedEventFromBenefitID({
  benefitID,
  search,
  page = 0,
}) {
  let data = null,
    err = null;

  const link = `kriya/web/search/benefit-pujas?page=${page}&query=${search}&benefitID=${benefitID}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(link),
  }).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export const sendOTPOnWhatsapp = async ({ contact, registrationID }) => {
  try {
    // if(!type){
    //   type = SMS_TEMPLATE.WEBSITE;
    // }
    // console.log("Send OTP called");
    const response = await axios({
      method: "POST",
      url: encodeURI("event/registration/sendOTPOnWhatsapp"),
      data: {
        contact: contact,
        registrationID,
      },
    }).catch((error) => printInConsole(error));

    printInConsole("SendOTP => ", response);
    return response.data;
  } catch (err) {
    printInConsole(err.message);
    alert(err.message);
  }
};

export const verifyOTPOnWhatsapp = async ({
  contact,
  otp,
  verificationKey,
}) => {
  try {
    const response = await axios({
      method: "POST",
      url: encodeURI("event/registration/verifyOTPFromWhatsapp"),
      data: {
        contact: contact,
        otp: otp,
        verificationKey: verificationKey,
      },
    }).catch((error) => printInConsole(error));

    printInConsole("VerifyOTP => ", response);
    return response.data;
  } catch (err) {
    printInConsole(err.message);
    alert(err.message);
  }
};

export const callPandit = async ({
  name,
  contact,
  eventLink,
  isDirectCall,
  problem,
  isKundali,
  kundaliDosh,
  callbackTiming,
}) => {
  // console.log("Call Pandit => ", name, contact, eventLink, isDirectCall);

  try {
    // if(!type){
    //   type = SMS_TEMPLATE.WEBSITE;
    // }
    // console.log("Send OTP called");
    const response = await axios({
      method: "POST",
      url: encodeURI("community/event/call-pandit"),
      data: {
        name,
        contact,
        eventLink,
        isDirectCall,
        problem,
        isKundali,
        kundaliDosh,
        callbackTiming,
      },
    }).catch((error) => printInConsole(error));

    printInConsole("Call Pandit => ", response);
    return response.data;
  } catch (err) {
    printInConsole(err.message);
    alert(err.message);
  }
};
